import { render, staticRenderFns } from "./volunteer-certificate.vue?vue&type=template&id=22035194&scoped=true"
import script from "./volunteer-certificate.vue?vue&type=script&lang=js"
export * from "./volunteer-certificate.vue?vue&type=script&lang=js"
import style0 from "./volunteer-certificate.vue?vue&type=style&index=0&id=22035194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22035194",
  null
  
)

export default component.exports